import { Fragment, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { isValidArray } from "../../../Layout/Common/common";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { loadScriptDropDown } from "../scripts";
import { PAGES } from "../../../routeConfig";
import { Link } from "react-router-dom";

export const WishListContainer = ({ prd }) => {
  const globalcontext = useContext(GlobalContext);
  const { addToWishList, handleWishList } = useGlobalFunction();
  const [listItem, setListItem] = useState(null);
  useEffect(() => {
    if (globalcontext.wishListAll) {
      setListItem(globalcontext.wishListAll);
      loadScriptDropDown();
    }
  }, [globalcontext.wishListAll]);

  const handleWishListAdd = async (listId) => {
    var param = { listId: listId, productId: prd.prod_id };
    const items = await addToWishList(param);
    if (items) setListItem(items);
  };

  return (
    <div className="dropdown proList-dropdown">
      <div
        className="dropdown-toggle wes-whishlist1 "
        id="proListDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        data-bs-auto-close="outside"
      />
      <div className="dropdown-menu dropdown-menu-lg-end" aria-labelledby="proListDropdown">
        {/* Dropdown inside content */}
        <div className="proList-dropdown-info">
          <h5>Save Product to List</h5>

          <div className="proList-dropdown-content">
            <h6>Select Product List</h6>
            {isValidArray(listItem) && (
              <div className="wishlist-created wishlist-createdList">
                {listItem.map((item, index) => (
                  <div className="wishlist-created-list" key={index}>
                    <p>
                      {item.listName} <small>({item.productCount})</small>
                    </p>
                    <span
                      className="wes-add"
                      onClick={() => {
                        handleWishListAdd(item.listId);
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
            <div className="noWishlist-created">
              <p>No List. Create New List </p>
            </div>
            <div className="proList-dropdown-create">
              <Link to={PAGES.FAVORITEPRODUCT_LIST}>Create New List</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
